import { Typography, Paper, Box } from "@mui/material";
import { INutritionFact } from "../../../models/ISkuDetail";
import colorConfigs from "../../../configs/colorConfigs";
import { fonts, typo } from "../../../assets/fonts/font";

interface NutritionFactProps {
  nutritionFact: INutritionFact;
}

const NutritionFact = ({ nutritionFact }: NutritionFactProps) => {
  const { header, nutrients } = nutritionFact;

  if (!header || !nutrients) return null;

  return (
    <Paper 
      sx={{ 
        maxWidth: 400, 
        margin: '0 auto',
        border: '2px solid var(--color-black)',
        borderRadius: 3,
        mt: 4,
        overflow: 'hidden',
        backgroundColor: colorConfigs.quaternary,
      }}
    >
      {/* Header */}
      <Box sx={{
        bgcolor: colorConfigs.tertiary,
        textAlign: 'center',
        pt:0.5,
        
      }}>
        <Typography
          sx={{
            fontFamily:fonts.bold,
            color: colorConfigs.secondary,
            fontSize: {
              xs: "20px",
              sm: "28px",
           },
          }}
        >
          Nutritional Information
        </Typography>

      </Box>

      {/* Serving Information */}
      <Box sx={{ p: 1.5, borderBottom: '1px solid var(--color-divider)' }}>
        <Typography sx={{ ...typo.bodyContent }}>
          Serving size: {header.servingSize}{header.servingUnit}
        </Typography>
        <Typography sx={{ ...typo.bodyContent }}>
          Servings per package: {header.servingsPerContainer}
        </Typography>
      </Box>

      {/* Column Headers */}
      <Box sx={{ 
        display: 'grid',
        gridTemplateColumns: { xs: '1fr 75px 75px' , sm:'1fr 100px 100px'},
        borderBottom: '2px solid var(--color-black)',
        borderTop: '2px solid var(--color-black)',
        p: 1
      }}>
        <Box />
        <Typography sx={{ 
          textAlign: 'center',
          ...typo.bodyContent,
        }}>
          Per Serving
        </Typography>
        <Typography sx={{ 
          ...typo.bodyContent,
          textAlign: 'center'
        }}>
          Per 100g
        </Typography>
      </Box>

      {/* Nutrients */}
      {nutrients.map((nutrient) => (
        <Box key={nutrient.id}>
          <Box sx={{ 
            display: 'grid',
            gridTemplateColumns: { xs: '1fr 75px 75px' , sm:'1fr 100px 100px'},
            p: 1
          }}>
            <Typography sx={{ ...typo.bodyContent }}>
              {nutrient.name}
            </Typography>
            <Typography sx={{ 
              ...typo.bodyContent,
              textAlign: 'center',
            }}>
              {nutrient.perserving}
            </Typography>
            <Typography sx={{ 
              ...typo.bodyContent,
              textAlign: 'center',
            }}>
              {nutrient.grams}
            </Typography>
          </Box>

          {/* Sub-nutrients */}
          {nutrient.subNutrients?.map((subNutrient, index) => (
            <Box 
              key={index}
              sx={{ 
                display: 'grid',
                gridTemplateColumns: { xs: '1fr 75px 75px' , sm:'1fr 100px 100px'},
                p: 1
              }}
            >
              <Typography sx={{ 
                ...typo.bodyContent,
                pl: 2
              }}>
                - {subNutrient.name}
              </Typography>
              <Typography sx={{ 
                ...typo.bodyContent,
                textAlign: 'center',
              }}>
                {subNutrient.perserving}
              </Typography>
              <Typography sx={{ 
                ...typo.bodyContent,
                textAlign: 'center',
              }}>
                {subNutrient.grams}
              </Typography>
            </Box>
          ))}
        </Box>
      ))}
    </Paper>
  );
};

export default NutritionFact;
